import { push } from 'redux-first-history';

import * as types from '../constants/cidraActions';
import { base85Encode } from '../util/base85Encoder';
import {
  setServerState,
  doStartDeviceManagementSession,
  doSetInitialTempCode,
  doSetSelfServiceDeviceManagementEnabled,
  completeAuthentication,
  finishLoading
} from './shared';
import { cidMobile, DecideNextStepProtocols } from '../constants/clientProtocols';
import { chooseModality, doInputIIDEnroll } from './chooseModality';
import {
  doSaveSkipSecondFactorToken, setSkipSecondFactorToken, setSsfAvailable, parsePeriodData
} from './skipSecondFactor';
import { logSsf } from '../util/log';
import { actuallyEndDeviceManagementSession } from './index';

export function decideNextStep(serverState, isCompleting, isWaitingForCompletion) {
  return function(dispatch, getState) {
    const {
      isDeviceManagementWorkflow, enableSkipSecondFactor, showInitialTempCode, capabilities,
      selfServiceSessionActive, sessionService, isHelpdeskVerificationWorkflow,
    } = getState().login;
    const {
      NxtStepResponseEnrollmentSuccessContinued,
      NxtStepResponseAuthErrorContinued,
      NxtStepResponseAuthSuccessContinued,
      NxtStepResponseEnrollmentSucceeded,
      NxtStepResponseAuthSucceeded,
    } = DecideNextStepProtocols;
    let isEnrollment = false;
    switch (serverState.responseType) {
    case (NxtStepResponseEnrollmentSuccessContinued):
      isEnrollment = true;
        console.log('EnrollmentSuccessContinued'); // eslint-disable-line
      // falls through
    case (NxtStepResponseAuthErrorContinued):
        !isEnrollment && console.log('AuthenticationErrorContinued'); // eslint-disable-line
      // falls through
    case (NxtStepResponseAuthSuccessContinued):
        !isEnrollment && console.log('AuthenticationSuccessContinued'); // eslint-disable-line

      // Note: for cidMobile, we do not use skip second factor (ssfAvailable will be set to false)
      const ssfAvailable = serverState && serverState.authContext !== undefined && serverState.authContext.ssfAvailable !== undefined & sessionService !== cidMobile ? serverState.authContext.ssfAvailable : false;
      const ssdmEnabled = (serverState && serverState.authContext !== undefined && serverState.authContext.ssdmEnabled !== undefined &&
                            capabilities !== undefined && capabilities.DeviceManagement !== undefined) ? serverState.authContext.ssdmEnabled === 'true' : false;

      if (ssfAvailable === 'true') {
        const ssfPeriodData = serverState.authContext.ssfPeriodData;
        dispatch(setSsfAvailable(ssfAvailable, parsePeriodData(ssfPeriodData) ) );
      }

      dispatch(doSetSelfServiceDeviceManagementEnabled(ssdmEnabled) );

      if (!isEnrollment || !isWaitingForCompletion) {
        dispatch(chooseModality(serverState, isEnrollment, showInitialTempCode) );
        if(showInitialTempCode) {
          dispatch(doSetInitialTempCode(false) );
        }
      }
      else {
        dispatch(setServerState(serverState) );
      }
      break;
    case (NxtStepResponseEnrollmentSucceeded):
      isEnrollment = true;
        console.log('EnrollmentSucceeded'); // eslint-disable-line
      // falls through
    case (NxtStepResponseAuthSucceeded):
        !isEnrollment && console.log('AuthenticationSucceeded'); // eslint-disable-line
      if (!selfServiceSessionActive) {
        if (isHelpdeskVerificationWorkflow) {
          dispatch(finishLoading() );
          dispatch(push('/helpdesk-verification-finish') );
        }
        else {
          dispatch(doLoginSuccess(serverState) );
        }
      }

      const deviceToken = serverState.deviceToken ? serverState.deviceToken : undefined;

      dispatch(setSkipSecondFactorToken(deviceToken) );

      const {
        enterpriseId, subscriberId, skipSecondFactorToken,
      } = getState().login;
      if (enableSkipSecondFactor && skipSecondFactorToken !== undefined) {
        logSsf('SSF was enabled and skipSecondFactorToken is not null. Therefore, the SSF token will be persisted.');
        doSaveSkipSecondFactorToken(enterpriseId, subscriberId, skipSecondFactorToken);
      }

      // If in a device management workflow, do not complete authentication.
      // Instead, navigate to IID enroll screen.
      if(!isCompleting && !isEnrollment && isDeviceManagementWorkflow) {
        console.log('Start device management session');
        dispatch(doStartDeviceManagementSession() );
        dispatch(push('/enrollimprivataid') );
        dispatch(doInputIIDEnroll(false, false) );
      }
      // After completing enrollment, there is an explanation screen,
      // so do not immediately submit the token.
      else if (!isEnrollment || isCompleting) {
        if(isDeviceManagementWorkflow) {
          dispatch(actuallyEndDeviceManagementSession() );
        }
        else {
          dispatch(completeAuthentication() );
          // cidMobile needs to display "wait for emr"
          if(sessionService === cidMobile) {
            dispatch(finishLoading() );
            dispatch(push('/waitingforemr') );
          }
        }
      }
      break;
    default:
      break;
    }
    return Promise.resolve();
  };
}

export function doLoginSuccess(serverState) {
  const encoding = serverState.tokenEncoding || 'Base64';
  let encodedToken;

  if (encoding === 'Base85') {
    encodedToken = base85Encode(serverState.authenticationToken);
  }
  else {
    encodedToken = btoa(serverState.authenticationToken.toString('binary') );
  }

  return {
    authenticationToken: encodedToken,
    serverState,
    type: types.LOGIN_SUCCESS,
  };
}
